export class RestoreLimitsModel {
    id;
    maxRestoreTimeInHours;
    maxAllowedActiveRequests;
    numOfActiveRequests;
    reachedMaxInProgressRequests;
}
//# sourceMappingURL=restore-limits.js.map